var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/node_modules/lodash/_Symbol.js
// module id = 263
// module chunks = 0